import {useMemo, useState} from "react"
import {CalendarOutlined} from "@ant-design/icons"
import {Tooltip} from "antd"
import {useTranslation} from "react-i18next"
import moment from "moment"
import {get} from "lodash"
import {OutcomeSelect} from "components/OutcomeSelect"
import {checkIsKeepSystemDateEvent} from "helpers/calendar"
import {Settings} from "types/settings"
import styles from "./CalendarEventsTable.module.css"
import {useAllCalendarEventTypes} from "hooks/useAllEventTypes"

export default function CalendarEventItem(props: {
    event: any
    outcomes?: Settings.Outcome[]
    isCalendarEvent?: boolean
    outcomeValue: any
    handleUpdateOutcome: (event: any, outcomeId: number) => void
}) {
    const {event, isCalendarEvent, outcomes, outcomeValue, handleUpdateOutcome} = props
    const {t} = useTranslation(["calendarEvents", "common"])
    const {eventTypes} = useAllCalendarEventTypes()
    const [outcome, setOutcome] = useState(outcomeValue)
    const startDateValue = isCalendarEvent ? event.start : event.start_at_utc
    const endDateValue = isCalendarEvent ? event.end : event.end_at_utc
    const startDate = startDateValue ? moment.utc(startDateValue).local().format("MMM D, YYYY h:mm A") : "-"
    const endDate = endDateValue ? moment.utc(endDateValue).local().format("MMM D, YYYY h:mm A") : "-"
    const department = get(event, "json_data.department.name") || "-"
    const eventType = get(event, "json_data.eventType") || "-"
    const eventTypeId = get(event, "json_data.eventTypeId")
    const eventOutcomes = useMemo(
        () =>
            eventTypes
                .find((type) => type.eventTypeId === eventTypeId)
                ?.outcomeGroups?.flatMap((group) => group.outcomes) || [],
        [eventTypes, eventTypeId]
    )

    return (
        <div className={styles.card}>
            <div className={styles.cardThumbnail}>
                <CalendarOutlined />
            </div>
            <div className={styles.cardBody}>
                <div className={styles.cardMeta}>
                    {eventType !== "-" ? eventType : t("calendarEvents.eventType")}
                    {department !== "-" && <span> &middot; {department}</span>}
                </div>
                <Tooltip title={event.title}>
                    <div className={styles.cardTitle}>{event.title || "-"}</div>
                </Tooltip>
                <div className={styles.cardSubtitle}>
                    <CalendarOutlined style={{fontSize: 11}} />
                    <span>{startDate}</span>
                </div>
            </div>
            <div className={styles.cardInfo}>
                <div className={styles.cardDateLabel}>{t("calendarEvents.endDate")}</div>
                <div className={styles.cardDateRange}>{endDate}</div>
            </div>

            <div className={styles.cardOutcome} onClick={(e) => e.stopPropagation()}>
                {!checkIsKeepSystemDateEvent(event.type) && (
                    <OutcomeSelect
                        value={outcome}
                        outcomes={outcomes ?? eventOutcomes}
                        onChange={(value) => {
                            setOutcome(value)
                            handleUpdateOutcome(event, value?.outcomeId)
                        }}
                        placeholder={t("calendarEvents.selectOutcome")}
                    />
                )}
            </div>
        </div>
    )
}
